export function time(ccc) {

    var data = ccc.substr(0, 19);
    var newDate = new Date(new Date(data.replace(/T/g, ' ').replace(/-/g, '/')).getTime() + 8 * 60 * 60 * 1000);
    var d = new Date(newDate);
    d = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
    return d
}


export function aVehicleConversion(ddd) {
    if (ddd < 60) {
        ddd = ddd + '秒'
        return ddd;
    } else {
        ddd = ddd + '分'
        return ddd / 60;
    }
}

